import Api from "../../Api"
import Request from "services/constants/Request.api"

class HeadOfDepartment extends Api {
  constructor(user) {
    super()
    this.user = user
  }
  getSubmittedApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/submitted/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getProcessingApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/processing/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getReviewedApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/reviewed/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // getOfficerReviewedApplications = () => {
  //   const request = new Request({
  //     data: {
  //       url: "applications/reviewed/departments/" + this.user.department_id,
  //       token: "Bearer " + this.user.token,
  //     },
  //   })

  //   return this.getRequest(request)
  // }

  // getDepartmentReturnedApplications = () => {
  //   const request = new Request({
  //     data: {
  //       url: "applications/returned/departments/" + this.user.department_id,
  //       token: "Bearer " + this.user.token,
  //     },
  //   })

  //   return this.getRequest(request)
  // }

  assignStaff = data => {
    const request = new Request({
      data: {
        staff_id: data.staff_id,
        assigned_by: this.user.id,
        application_id: data.application_id,
        url: "applications/assign/" + this.user.department_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  reviewApplication = data => {
    const request = new Request({
      data: {
        reason: data.reason,
        comment_to_applicant: data.comment_to_applicant,
        decision_code: data.decision_code,
        application_id: data.application_id,
        url: "staff/application/department/review/" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getHoDReviewDetails = data => {
    const request = new Request({
      data: {
        url: "application/hod-review?application_id=" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getApprovedApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/approved/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getRejectedApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/rejected/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getStatistics = () => {
    const request = new Request({
      data: {
        url: "staff/statistics/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  uploadFile = fileDetails => {
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", fileDetails.application_id)
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        url: "applications/upload/file",
        token: "Bearer " + this.user.token,
      },
    })
    return this.uploadRequest(request)
  }

  getDepartmentReturnedApplications = page => {
    const request = new Request({
      data: {
        url:
          "applications/sent-back/departments/" +
          this.user.department_id +
          "?page=" +
          page,
        token: "Bearer " + this.user.token,
      },
    })
    console.log(request)

    return this.getRequest(request)
  }

}

export default HeadOfDepartment
